import { render, staticRenderFns } from "./AddDbSidePanel.vue?vue&type=template&id=28e343d4&"
import script from "./AddDbSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddDbSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports